import { createMuiTheme } from "@material-ui/core/styles";

const theme = createMuiTheme({
  palette: {
    primary: {
      main: "#003366", // your primary color
    },

    text: {
      primary: "#021B35", // your dark text color
    },
  },

  typography: {
    fontFamily: "Lato, Arial, sans-serif",
    allVariants: {
      color: "#021B35",
    },
  },

  overrides: {
    MuiButton: {
      root: {
        borderRadius: 6,
        textTransform: "none",
        fontWeight: 400,
        backgroundColor: "#003366",
        color: "white",
      },

      containedPrimary: {
        backgroundColor: "#003366",
        "&:hover": {
          backgroundColor: "#00284d", // slightly darker hover
        },
      },

      outlined: {
        borderWidth: 1,
        borderColor: "#021B35",
        color: "#021B35",
        background: "transparent",
        "&:hover": {
          borderWidth: 1,
          backgroundColor: "rgba(0, 51, 102, 0.04)",
        },
      },
    },

    MuiTypography: {
      root: {
        color: "#021B35",
      },
    },

    MuiOutlinedInput: {
      root: {
        height: 40,
        borderRadius: 6,
        paddingInline: 8,
      },

      input: {
        // padding: "10px 14px",
      },
    },

    MuiSwitch: {
      root: {
        width: 44,
        height: 24,
        padding: 0,
      },

      switchBase: {
        padding: 2,
        color: "#fff",

        "&$checked": {
          transform: "translateX(20px)",
          color: "#fff",
          "& + $track": {
            backgroundColor: "#003366 !important",
            opacity: 1,
            border: "none",
          },
        },
      },

      thumb: {
        width: 20,
        height: 20,
        backgroundColor: "#fff",
      },

      track: {
        borderRadius: 15,
        backgroundColor: "#BDBDBD",
        opacity: 1,
      },

      checked: {},
    },
  },
});

export default theme;
